module.exports = __webpack_public_path__ + "static/img/third2_2_1.22fe9993.jpg";